import { Observable, pipe } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { Loader, LoaderType } from '../utils/loader.util';
import { trackExecutionHttp } from './track-execution-http.operator';

export const switchMapAndTrack = (dataSourceFn: (data: unknown) => Observable<unknown>, loaderType: LoaderType, loader: Loader = Loader.instance) => pipe(
  switchMap((data) => dataSourceFn(data).pipe(
    trackExecutionHttp(loaderType, loader),
  )),
);
